import * as actions from './HealthFiltersActionsType';
import HealthFiltersService from './HealthFiltersService';

const set = (type, payload) => dispatcher => dispatcher({type, payload});

export const setCardView = view => set(actions.SET_CARDVIEW, view);
export const setChips = chips => set(actions.SET_CHIP, chips);
export const setGroups = groups => set(actions.SET_GROUPS, groups);
export const setHealthStatus = status => set(actions.SET_STATUS, status);
export const clearHidableFilters = () => set(actions.CLEAR_HIDEABLE)
export const clearFilterMobile = () => set(actions.CLEAR_FILTER_MOBILE)

export const loadGroups = () => async dispatcher => {
  dispatcher({type: actions.GROUPS_REQUEST});
  try {
    const payload = await HealthFiltersService.loadGroups();
    dispatcher({type: actions.GROUPS_SUCCESS, payload});
  } catch (e) {
    console.error(e);
    dispatcher({type: actions.GROUPS_FAILURE});
  }
};

export const predict = text => async dispatcher => {
  dispatcher({type: actions.SEARCH_REQUEST});
  try {
    const payload = await HealthFiltersService.predict(text);
    dispatcher({type: actions.SEARCH_SUCCESS, payload});
  } catch (e) {
    console.error(e);
    dispatcher({type: actions.SEARCH_FAILURE});
  }
};

export const loadHealthStatus = () => async dispatcher => {
  dispatcher({type: actions.STATUS_REQUEST});
  try {
    const payload = await HealthFiltersService.loadHealthStatus();
    dispatcher({type: actions.STATUS_SUCCESS, payload});
  } catch (e) {
    console.error(e);
    dispatcher({type: actions.STATUS_FAILURE});
  }
};
